"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // @ts-nocheck

var v4_1 = __importDefault(require("uuid/v4"));

var ASSET_TYPES = __importStar(require("./types"));

function initialState(type) {
  var base = {
    class: "asset",
    type: type,
    subType: null,
    subTypeOtherDescription: null,
    value: null,
    valueOwned: null,
    portionOwned: null,
    valueLiens: null,
    additionalDescription: null,
    // SOFA - Seized Property (see above ref)
    seizure: null,
    closedAt: null,
    accountNumber: null,
    // Schedule C
    exemptions: [],
    // Insurance Policies
    beneficiary: null // NOTE: some party

  };

  if (type === ASSET_TYPES.PROPERTY) {
    base = _objectSpread(_objectSpread({}, base), {}, {
      interest: null,
      interestDescription: null,
      community: false,
      address: null
    });
  } else if (type === ASSET_TYPES.VEHICLE) {
    base = _objectSpread(_objectSpread({}, base), {}, {
      interest: null,
      interestDescription: null,
      community: false,
      make: null,
      model: null,
      year: null,
      estimatedMileage: null
    });
  } else if (type === ASSET_TYPES.FINANCIAL) {
    base = _objectSpread(_objectSpread({}, base), {}, {
      party: null,
      accessibleBy: null // Party that also has access to asset

    });
  } else if (type === ASSET_TYPES.BUSINESS) {
    base = _objectSpread(_objectSpread({}, base), {}, {
      name: null,
      address: null,
      accessibleBy: null,
      ein: null,
      startedAt: null,
      endedAt: null
    });
  }

  return base;
}

var createAsset = function createAsset(type, attrs) {
  return _objectSpread(_objectSpread(_objectSpread({}, initialState(type)), {}, {
    type: type
  }, attrs), {}, {
    id: (0, v4_1.default)()
  });
};

exports.default = createAsset;